import React, { useRef, useState, useMemo } from 'react';
import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import interactionPlugin from '@fullcalendar/interaction';
import { format } from 'date-fns';
import "./style.css";
import { Box, Button, Container, Grid, useMediaQuery, useTheme } from '@mui/material';
import POSHeader from 'components/POSHeader';
import { ThemeProvider } from 'theme/ThemeContext2'
import { useSelector } from 'react-redux';
import SummaryCard from 'components/SummaryCard/SummaryCard';
import HistoryIcon from "@mui/icons-material/History";
import CustomButton from 'components/Fileds/CustomButton';
import AddIcon from "@mui/icons-material/Add"
import { useOrder } from 'context/OrderContext';
import isToday from 'date-fns/isToday'; // import at top
import { ReactComponent as LeftArrow } from "assests/left-arrow-group.svg";
import { ReactComponent as RightArrow } from "assests/right-arrow-group.svg";
import CustomTypography from 'components/Fileds/CustomTypography';
import PersonIcon from '@mui/icons-material/Person';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CalendarSchedulerSkeleton from './CalendarSchedulerSkeleton';
import { getOrderTypePermissions, isPermissionAllowed } from 'utils/function';
import DatePickerPopover from './components/DatePickerPopover';

function renderEventContent(arg) {
    const startHHMM = format(arg.event.start, 'HH:mm')
    const { guestCount, borderColor, opacity, isAvailable } = arg.event.extendedProps
    return (
        <div className='d-flex calendar-event-container'
            style={{
                backgroundColor: arg.event.backgroundColor,
                border: `1px solid ${borderColor}`,
                cursor: 'pointer',
                opacity: opacity,
                // padding: '2px 5px'
            }}
        >
            <CustomTypography
                variant="body2"
                label={arg.event.title}
                sx={{ mb: 0.5, fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: isAvailable ? 600 : 400 }}
            />
            {!isAvailable && (
                // <div className='d-flex align-items-center' style={{ gap: 2 }}>
                //     <CustomTypography variant="body2" label={`${startHHMM} | `} sx={{ fontSize: '12px', mb: 0 }} />
                //     <PersonIcon sx={{ fontSize: '14px' }} />
                //     <CustomTypography variant="body2" label={guestCount} sx={{ fontSize: '12px', mb: 0 }} />
                // </div>
                <div className='d-flex align-items-center' style={{ gap: 2 }}>
                    <CustomTypography variant="body2" label={`${startHHMM} | `} sx={{ fontSize: '12px', mb: 0 }} />
                    <PersonIcon sx={{ fontSize: '14px' }} />
                    <CustomTypography variant="body2" label={guestCount} sx={{ fontSize: '12px', mb: 0 }} />
                </div>
            )}
            {isAvailable && (
                <div className='d-flex align-items-center' style={{ gap: 2 }}>
                    <CustomTypography variant="body2" label={startHHMM} sx={{ fontSize: '12px', mb: 0 }} />
                </div>
            )}
        </div>
    );
}

const CalendarContainer = ({ tables, bookings, orderSummary, handleViewPastOrders, handleDatesSet, currentDate, setCurrentDate, onEventClick, isLoading = false }) => {
    const loginData = useSelector((state) => state?.posData);
    const permissions = useMemo(() => getOrderTypePermissions(loginData), [loginData]);
    const isTakeAwayAllowed = isPermissionAllowed(permissions, 'permission_take_away');
    const isDineInAllowed = isPermissionAllowed(permissions, 'permission_pos_walk_in_order');
    const isTableBookingAllowed = isPermissionAllowed(permissions, 'permission_table_booking');

    const theme = useTheme()
    const isSmall = useMediaQuery(theme.breakpoints.down("sm"))
    const { openDialog } = useOrder();
    const calendarApiRef = useRef(null);
    const [is24Hour, setIs24Hour] = useState(true);
    const [calendarAnchorEl, setCalendarAnchorEl] = useState(null);
    const isCalendarOpen = Boolean(calendarAnchorEl);

    const handleSelectDate = (date) => {
        setCurrentDate(date);
        if (calendarApiRef.current) {
            calendarApiRef.current.getApi().gotoDate(date);
        }
    };
    return (
        <ThemeProvider>
            <Box className='order-listing' sx={{ bgcolor: "#fff", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <POSHeader />
                <Box className="pos-container calendar-container" sx={{ flexGrow: 1, padding: '0px' }}>
                    <Container
                        maxWidth={false}
                        disableGutters
                        sx={{
                            py: 1,
                            maxWidth: "1400px",
                            mx: "auto",
                        }}
                    >
                        <Box sx={{ padding: '10px 48px' }}>
                            {/* <Box className='d-flex align-items-center justify-content-between' sx={{mb:3}}>
                                <Box className='d-flex'>
                                    20 December 2025
                                </Box>

                                <Box className='d-flex align-items-center' sx={{ gap: '50px' }}>
                                    <Grid className='d-flex align-items-center order-summary-container' sx={{ gap: 3 }}>
                                        {orderSummary?.map((item) => (
                                            <Grid item xs={6} sm={6} md={4} sx={{ width: '100%' }}>
                                                <SummaryCard
                                                    item={item}
                                                    isSmall={isSmall}
                                                    theme={theme}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>

                                    <RestaurantInfo name={loginData?.vendor?.name} description={loginData?.vendor?.tagline} />
                                </Box>
                            </Box> */}

                            <Grid container className='align-items-center justify-content-between' sx={{ mb: 4 }}>
                                <Grid item xs={12} sm={4} md={2.8}>
                                    <Grid container spacing={2} className="btn-container" sx={{ alignItems: 'center' }}>
                                        {/* {!isToday(currentDate) && ( */}
                                        <Grid item xs={12} sx={{ visibility: isToday(currentDate) ? 'hidden' : 'visible', paddingTop: '5px !important' }}>
                                            <CustomTypography
                                                className='cursor-pointer'
                                                sx={{ fontSize: '14px', color: '#00409E', textTransform: 'none', textDecoration: 'underline', mb: 1, paddingLeft: '40px', fontWeight: '600' }}
                                                onClick={() => {
                                                    const today = new Date();
                                                    calendarApiRef.current.getApi().today(); // reset view
                                                    setCurrentDate(today);
                                                }}
                                                label={"Go back to Today"}
                                            />
                                        </Grid>
                                        {/* )} */}

                                        <Grid item sx={{ paddingTop: '0px !important' }}>
                                            {/* <Button onClick={() => calendarApiRef.current.getApi().prev()}></Button> */}
                                            <LeftArrow className='cursor-pointer' onClick={() => calendarApiRef.current.getApi().prev()} />
                                        </Grid>
                                        <Grid item sx={{ paddingTop: '0px !important' }}>
                                            <Box sx={{ textAlign: 'center', lineHeight: 1.3 }}>
                                                <CustomTypography
                                                    label={format(currentDate, 'd MMMM yyyy')}
                                                    variant="body1"
                                                    sx={{ fontWeight: 500, mb: 0 }}
                                                />
                                                <CustomTypography
                                                    label={format(currentDate, 'EEEE')}
                                                    variant="body2"
                                                    sx={{ fontWeight: 400, color: theme.palette.drawermenuitem.main, mb: 0 }}
                                                />
                                            </Box>
                                        </Grid>
                                        <Grid item sx={{ paddingTop: '0px !important' }}>
                                            {/* <Button onClick={() => calendarApiRef.current.getApi().next()}>→</Button> */}
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <RightArrow className='cursor-pointer' onClick={() => calendarApiRef.current.getApi().next()} />
                                                <Box
                                                    onClick={(e) => setCalendarAnchorEl(e.currentTarget)}
                                                    className="cursor-pointer"
                                                    title="Select Date"
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        width: '32px',
                                                        height: '32px',
                                                        borderRadius: '50%',
                                                        border: '1.5px solid #000',
                                                        bgcolor: isCalendarOpen ? '#EFF6FF' : '#FFFFFF',
                                                        color: '#000',
                                                        transition: 'all 0.15s ease',
                                                        marginLeft: '10px',
                                                        boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                                                        '&:hover': {
                                                            bgcolor: '#EFF6FF',
                                                            borderColor: '#000',
                                                            color: '#000',
                                                        },
                                                    }}
                                                >
                                                    <CalendarMonthOutlinedIcon sx={{ fontSize: '18px' }} />
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} sm={8} md={9.2} className='align-items-center'>
                                    <Grid container>
                                        <Grid item xs={10} sm={10} md={10}>
                                            <Box className='d-flex align-items-center order-summary-container' sx={{ gap: 3, marginTop: '10px' }}>
                                                {orderSummary?.map((item) => (
                                                    <Box sx={{ width: '100%' }} key={item.id}>
                                                        <SummaryCard
                                                            item={item}
                                                            isSmall={isSmall}
                                                            theme={theme}
                                                            isLoading={isLoading}
                                                        />
                                                    </Box>
                                                ))}
                                            </Box>
                                        </Grid>
                                        {/* <Grid item xs={2} sm={10} md={2}>
                                            <RestaurantInfo name={loginData?.vendor?.name} description={loginData?.vendor?.tagline} mt={"0px"} mb={"0px"} sx={{ alignContent: 'center', height: '100%' }} />
                                        </Grid> */}
                                    </Grid>

                                </Grid>
                            </Grid>

                            {/* <Grid container className='align-items-center btn-container' spacing={2}>
                                <Grid item xs={2} sm={2} md={2.5} sx={{ paddingLeft: '16px !important' }}>
                                    <Button className='time-format-calendar-btn'
                                          onClick={() => setIs24Hour((f) => !f)}
                                    >
                                        <div className="btn-text-title">Time Format</div>
                                        <div className="btn-text-subtitle">{is24Hour ? '24 HRS' : '12 HRS'}</div>
                                    </Button>
                                </Grid>

                                <Grid item xs={10} sm={10} md={9.5}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6} sm={6} md={3} lg={3}>
                                            <Button
                                                variant="outlined"
                                                startIcon={<HistoryIcon />}
                                                onClick={handleViewPastOrders}
                                                sx={{ textTransform: 'none', width: '100%', padding: '7px', borderRadius: '10px', height:'45px', border:'1px solid #000' }}
                                            >
                                                View Past Orders
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={3} lg={3}>
                                            <CustomButton
                                                variant="contained"
                                                startIcon={<AddIcon />}
                                                fullWidth
                                                size={"medium"}
                                                sx={{
                                                    borderRadius: "10px",
                                                    // width: "220px",
                                                    textTransform: "none",
                                                    height:'45px'
                                                }}
                                                onClick={() => openDialog('takeAway')}
                                            >
                                                Take Away Order
                                            </CustomButton>

                                        </Grid>
                                        <Grid item xs={6} sm={6} md={3} lg={3}>
                                            <CustomButton
                                                variant="contained"
                                                startIcon={<AddIcon />}
                                                fullWidth
                                                size={"medium"}
                                                sx={{
                                                    borderRadius: "10px",
                                                    // width: "220px",
                                                    textTransform: "none",
                                                    height:'45px' 
                                                }}
                                                // onClick={() => window.dispatchEvent(new CustomEvent("openDineInDialog"))}
                                                onClick={() => openDialog('dineIn')}
                                                >
                                                Dine-In Order
                                            </CustomButton>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={3} lg={3}>
                                            <CustomButton
                                                variant="contained"
                                                startIcon={<AddIcon />}
                                                fullWidth
                                                size={"medium"}
                                                sx={{
                                                    borderRadius: "10px",
                                                    // width: "220px",
                                                    textTransform: "none",
                                                    height:'45px' 
                                                }}
                                                // onClick={() => window.dispatchEvent(new CustomEvent("openTableBookingDialog"))}
                                                onClick={() => openDialog('tableBooking')}
                                            >
                                                Table Booking
                                            </CustomButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid> */}
                            <Grid container className='align-items-center btn-container' spacing={'30px'}>
                                <Grid item xs={2} sm={2} md={3.5}>
                                    <Box className='d-flex align-items-center' gap={'30px'}>
                                        <Button className='time-format-calendar-btn'
                                            onClick={() => setIs24Hour((f) => !f)}
                                        >
                                            <div className="btn-text-title">Time Format</div>
                                            <div className="btn-text-subtitle">{is24Hour ? '24 HRS' : '12 HRS'}</div>
                                        </Button>

                                        {/* <Grid item xs={6} sm={6} md={3} lg={3}> */}
                                        <Button
                                            variant="outlined"
                                            startIcon={<HistoryIcon />}
                                            onClick={handleViewPastOrders}
                                            sx={{ textTransform: 'none', width: '200px', padding: '7px', borderRadius: '10px', height: '45px', border: '1px solid #000' }}
                                        >
                                            View Past Orders
                                        </Button>
                                        {/* </Grid> */}
                                    </Box>
                                </Grid>

                                <Grid item xs={10} sm={10} md={8.5}>
                                    <Grid container spacing={'30px'}>
                                        {isTakeAwayAllowed && (
                                            <Grid item xs={6} sm={3} md={4} lg={4}>
                                                <CustomButton
                                                    variant="contained"
                                                    startIcon={<AddIcon />}
                                                    fullWidth
                                                    size={"medium"}
                                                    sx={{
                                                        borderRadius: "10px",
                                                        // width: "220px",
                                                        textTransform: "none",
                                                        height: '45px'
                                                    }}
                                                    onClick={() => openDialog('takeAway')}
                                                >
                                                    Take Away Order
                                                </CustomButton>
                                            </Grid>
                                        )}
                                        {isDineInAllowed && (
                                            <Grid item xs={6} sm={3} md={4} lg={4}>
                                                <CustomButton
                                                    variant="contained"
                                                    startIcon={<AddIcon />}
                                                    fullWidth
                                                    size={"medium"}
                                                    sx={{
                                                        borderRadius: "10px",
                                                        // width: "220px",
                                                        textTransform: "none",
                                                        height: '45px'
                                                    }}
                                                    // onClick={() => window.dispatchEvent(new CustomEvent("openDineInDialog"))}
                                                    onClick={() => openDialog('dineIn')}
                                                >
                                                    Dine-In Order
                                                </CustomButton>
                                            </Grid>
                                        )}
                                        {isTableBookingAllowed && (
                                            <Grid item xs={6} sm={3} md={4} lg={4}>
                                                <CustomButton
                                                    variant="contained"
                                                    startIcon={<AddIcon />}
                                                    fullWidth
                                                    size={"medium"}
                                                    sx={{
                                                        borderRadius: "10px",
                                                        // width: "220px",
                                                        textTransform: "none",
                                                        height: '45px'
                                                    }}
                                                    // onClick={() => window.dispatchEvent(new CustomEvent("openTableBookingDialog"))}
                                                    onClick={() => openDialog('tableBooking')}
                                                >
                                                    Table Booking
                                                </CustomButton>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                        {isLoading ? (
                            <CalendarSchedulerSkeleton />
                        ) : (
                            <div
                                className="table-scheduler-wrapper calendar-table"
                                style={{
                                    overflowX: 'auto',
                                    borderRadius: 4,
                                    margin: '30px 0px'
                                }}
                            >
                                <FullCalendar
                                    ref={calendarApiRef}
                                    plugins={[resourceTimelinePlugin, interactionPlugin]}
                                    schedulerLicenseKey="CC-Attribution-NonCommercial-NoDerivatives"
                                    timeZone="local"
                                    initialView="resourceTimelineDay"
                                    nowIndicator={true}
                                    headerToolbar={false}
                                    datesSet={handleDatesSet}
                                    eventClick={(info) => onEventClick(info.event)}
                                    views={{
                                        // timeline: {
                                        //     columnWidth: 'large'
                                        // },
                                        resourceTimelineDay: {
                                            type: 'resourceTimeline',
                                            duration: { days: 1 },
                                            // slotDuration: '01:00:00',
                                            slotDuration: '00:01:00',            // move indicator every minute
                                            slotLabelInterval: { hours: 1 },
                                            slotLabelFormat: {
                                                hour: 'numeric',
                                                minute: '2-digit',
                                                hour12: !is24Hour
                                            },
                                            slotMinWidth: 50,
                                            slotLabelContent: (arg) => {
                                                // Format using native Intl API
                                                const formatted = new Intl.DateTimeFormat('en-US', {
                                                    hour: 'numeric',
                                                    minute: '2-digit',
                                                    hour12: !is24Hour
                                                }).format(arg.date);

                                                // Convert AM/PM to lowercase if in 12-hour mode
                                                return {
                                                    html: !is24Hour ? formatted.replace(/AM|PM/, (m) => m.toLowerCase()) : formatted
                                                };
                                            }

                                        },
                                    }}
                                    slotMinTime="00:00:00"
                                    slotMaxTime="24:00:00"
                                    resourceAreaHeaderContent="Tables"
                                    resources={tables}
                                    events={bookings}
                                    eventContent={renderEventContent}
                                    height="auto"
                                    resourceAreaWidth="120px"
                                // dayHeaderFormat={{ weekday: 'short', day: 'numeric' }}
                                // editable={true}
                                />
                            </div>
                        )}

                        {/* Date Picker Popover */}
                        <DatePickerPopover
                            anchorEl={calendarAnchorEl}
                            open={isCalendarOpen}
                            onClose={() => setCalendarAnchorEl(null)}
                            selectedDate={currentDate}
                            onSelectDate={handleSelectDate}
                        />
                    </Container>
                </Box>
            </Box>
        </ThemeProvider>
    );
};

export default CalendarContainer;
